import { render, staticRenderFns } from "./newsletter.vue?vue&type=template&id=be2dbe3e&scoped=true"
import script from "./newsletter.vue?vue&type=script&lang=js"
export * from "./newsletter.vue?vue&type=script&lang=js"
import style0 from "./newsletter.vue?vue&type=style&index=0&id=be2dbe3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2dbe3e",
  null
  
)

export default component.exports